import appPaymentMethods from "../../views/appSettings/paymentMethodsView.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "payment-methods";
  const params = ["page', 'limit"];

  $stateProvider.state("paymentmethods", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appPaymentMethods,
      },
    },
    reloadOnSearch: false,
    data: { title: "PaymentMethods" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/paymentMethods/paymentMethods.urls.js